import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUser, deleteUser, createUser, updateUserPhoto } from "../services/userApi";

export function useCreateUser(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createUser,
    onSuccess: (data) => {
      console.log(`${data.fname} has been saved successfully!`);
      queryClient.setQueryData([queryData], (old) => (old ? [...old, data] : data));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateUser(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUser,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      console.log(`${data.fname} has been saved successfully!`);
      queryClient.setQueryData([queryData], (old) => old?.map((item) => (item.id === data.id ? data : item)));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateUserPhoto(queryData, handleSuccess, handleError) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUserPhoto,
    onSuccess: (data) => {
      queryClient.setQueryData([queryData], (old) => old?.map((item) => (item.id === data.id ? data : item)));
      handleSuccess?.(data);
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useDeleteUser(queryData, handleSuccess, handleError) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: (data, publicId) => {
      console.log(`${publicId} has been removed successfully!`);
      queryClient.setQueryData([queryData], (old) => old?.filter((item) => item.public_id !== publicId));
      handleSuccess?.();
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}
